<form [formGroup]="form" class="formgrid grid">
    <div class="col-6 grid">
        <div class="field col-12">
            <label>Telefonbucheintrag</label>
            <div class="flex flex-wrap gap-3 mb-3">
                <div class="flex align-items-center">
                    <p-radioButton value="none" formControlName="type" inputId="typeInputNone"></p-radioButton>
                    <label for="typeInputNone" class="ml-2">kein Eintrag</label>
                </div>
                <div class="flex align-items-center">
                    <p-radioButton value="full" formControlName="type" inputId="typeInputFull"></p-radioButton>
                    <label for="typeInputFull" class="ml-2">vollständiger Eintrag</label>
                </div>
                <div class="flex align-items-center">
                    <p-radioButton value="short" formControlName="type" inputId="typeInputShort"></p-radioButton>
                    <label for="typeInputShort" class="ml-2">verkürzter Eintrag</label>
                </div>
            </div>
        </div>
        <ng-container *ngIf="(form.controls.type.value !== 'none')">
            <div class="field col-12">
                <label>Inverssuche</label>
                <div class="flex flex-wrap gap-3 mb-3">
                  <div class="flex align-items-center">
                    <p-radioButton [value]="false" formControlName="inverse" inputId="inverseInputFalse"></p-radioButton>
                    <label for="inverseInputFalse" class="ml-2">Nein, Inverssuche nicht erlauben</label>
                  </div>
                  <div class="flex align-items-center">
                    <p-radioButton [value]="true" formControlName="inverse" inputId="inverseInputTrue"></p-radioButton>
                    <label for="inverseInputTrue" class="ml-2">Ja, Inverssuche erlauben</label>
                  </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="col-6" *ngIf="(form.controls.type.value !== 'none')">
        <ng-container *ngIf="{ contactData: (customerDataService.contactData$ | async), portingData: (portingService.portingData$ | async) } as phoneBookEntry">
            <ow-phone-book-entry [type]="form.controls.type.value" [contactData]="phoneBookEntry.contactData" [portingData]="phoneBookEntry.portingData" [streetName]="addressesService.getStreetName()" [streetNumber]="addressesService.getStreetNumber()" [postalCode]="addressesService.getPostalCode()" [city]="addressesService.getCity()"></ow-phone-book-entry>
        </ng-container>
    </div>
    <div class="field col-12">
        <label>Einzelverbindungsnachweis</label>
        <div class="flex flex-wrap gap-3 mb-3">
            <div class="flex align-items-center">
                <p-radioButton value="none" formControlName="evn" inputId="evnInputNone"></p-radioButton>
                <label for="evnInputNone" class="ml-2">kein Einzelverbindungsnachweis</label>
            </div>
            <div class="flex align-items-center">
                <p-radioButton value="full" formControlName="evn" inputId="evnInputFull"></p-radioButton>
                <label for="evnInputFull" class="ml-2">vollständiger Einzelverbindungsnachweis</label>
            </div>
            <div class="flex align-items-center">
                <p-radioButton value="short" formControlName="evn" inputId="evnInputShort"></p-radioButton>
                <label for="evnInputShort" class="ml-2">eingeschränkter Einzelverbindungsnachweis</label>
            </div>
        </div>
    </div>
    <div class="field col-12" *ngIf="showEvnNote">
        <label>{{ evnNoteTitle }}</label>
        <div class="flex align-items-start gap-2">
            <p-checkbox formControlName="evnNote" [binary]="true" styleClass="mt-1"></p-checkbox>
            <label>{{ evnNoteText }}</label>
        </div>
    </div>
</form>
